import Model from 'mixins/model';

export default class NotificationStatusModel extends Model {
    constructor() {
        super();
    }
    setArticles(count) {
      this.set('articles', count);
      this.fireEvent('articlesRefreshed', count);
    }
    setSystemNotification(count) {
      this.set('system', count);
      this.fireEvent('systemRefreshed', count);
    }
    static fromJSON(data) {
        const {
          articles,
          system,
        } = data;

        const notificationStatusModel = new NotificationStatusModel();

        notificationStatusModel.set('articles', (articles) ? parseInt(articles) : 0);
        notificationStatusModel.set('system', (system) ? parseInt(system) : 0);

        return notificationStatusModel;
    }
};

export const notificationStatusModel = new NotificationStatusModel();



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/models/NotificationStatusModel.js